!function() {
    "use strict";
    var e = function() {
        return (e = Object.assign || function(e) {
            for (var t, i = 1, n = arguments.length; i < n; i++)
                for (var o in t = arguments[i])
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
            return e
        }
        ).apply(this, arguments)
    };
    function t(e, t, i) {
        for (var n, o = 0, r = t.length; o < r; o++)
            !n && o in t || (n || (n = Array.prototype.slice.call(t, 0, o)),
            n[o] = t[o]);
        return e.concat(n || Array.prototype.slice.call(t))
    }
    function i(e) {
        return Array.prototype.slice.call(e)
    }
    function n(e, t) {
        var i = Math.floor(e);
        return i === t || i + 1 === t ? e : t
    }
    function o() {
        return Date.now()
    }
    function r(e, t, i) {
        if (t = "data-keen-slider-" + t,
        null === i)
            return e.removeAttribute(t);
        e.setAttribute(t, i || "")
    }
    function a(e, t) {
        return t = t || document,
        "function" == typeof e && (e = e(t)),
        Array.isArray(e) ? e : "string" == typeof e ? i(t.querySelectorAll(e)) : e instanceof HTMLElement ? [e] : e instanceof NodeList ? i(e) : []
    }
    function l(e) {
        e.raw && (e = e.raw),
        e.cancelable && !e.defaultPrevented && e.preventDefault()
    }
    function s(e) {
        e.raw && (e = e.raw),
        e.stopPropagation && e.stopPropagation()
    }
    function d() {
        var e = [];
        return {
            add: function(t, i, n, o) {
                t.addListener ? t.addListener(n) : t.addEventListener(i, n, o),
                e.push([t, i, n, o])
            },
            input: function(e, t, i, n) {
                this.add(e, t, function(e) {
                    e.nativeEvent && (e = e.nativeEvent);
                    var t = e.changedTouches || []
                      , n = e.targetTouches || []
                      , o = e.detail && e.detail.x ? e.detail : null;
                    return i({
                        id: o ? o.identifier ? o.identifier : "i" : n[0] ? n[0] ? n[0].identifier : "e" : "d",
                        idChanged: o ? o.identifier ? o.identifier : "i" : t[0] ? t[0] ? t[0].identifier : "e" : "d",
                        raw: e,
                        x: o && o.x ? o.x : n[0] ? n[0].screenX : o ? o.x : e.pageX,
                        y: o && o.y ? o.y : n[0] ? n[0].screenY : o ? o.y : e.pageY
                    })
                }, n)
            },
            purge: function() {
                e.forEach(function(e) {
                    e[0].removeListener ? e[0].removeListener(e[2]) : e[0].removeEventListener(e[1], e[2], e[3])
                }),
                e = []
            }
        }
    }
    function u(e, t, i) {
        return Math.min(Math.max(e, t), i)
    }
    function v(e) {
        return (e > 0 ? 1 : 0) - (e < 0 ? 1 : 0) || +e
    }
    function c(e) {
        var t = e.getBoundingClientRect();
        return {
            height: n(t.height, e.offsetHeight),
            width: n(t.width, e.offsetWidth)
        }
    }
    function h(e, t, i, n) {
        var o = e && e[t];
        return null == o ? i : n && "function" == typeof o ? o() : o
    }
    function g(e) {
        return Math.round(1e6 * e) / 1e6
    }
    function p(e) {
        var t, i, n, o, r, a, l, s;
        function d(e) {
            return 1 - Math.pow(1 - e, 3)
        }
        function c() {
            return n ? e.track.velocity() : 0
        }
        function h(e, t) {
            void 0 === t && (t = 1e3);
            var i = 147e-9 + (e = Math.abs(e)) / t;
            return {
                dist: Math.pow(e, 2) / i,
                dur: e / i
            }
        }
        function g() {
            var t = e.track.details;
            t && (r = t.min,
            a = t.max,
            l = t.minIdx,
            s = t.maxIdx)
        }
        function p() {
            e.animator.stop()
        }
        e.on("updated", g),
        e.on("optionsChanged", g),
        e.on("created", g),
        e.on("dragStarted", function() {
            n = !1,
            p(),
            t = i = e.track.details.abs
        }),
        e.on("dragChecked", function() {
            n = !0
        }),
        e.on("dragEnded", function() {
            var n, g, m, f, b, y, S = e.options.mode;
            "snap" === S && (n = e.track,
            m = (g = e.track.details).position,
            f = v(c()),
            (m > a || m < r) && (f = 0),
            b = t + f,
            0 === g.slides[n.absToRel(b)].portion && (b -= f),
            t !== i && (b = i),
            v(n.idxToDist(b, !0)) !== f && (b += f),
            b = u(b, l, s),
            y = n.idxToDist(b, !0),
            e.animator.start([{
                distance: y,
                duration: 500,
                easing: function(e) {
                    return 1 + --e * e * e * e * e
                }
            }])),
            "free" !== S && "free-snap" !== S || function() {
                p();
                var t = "free-snap" === e.options.mode
                  , i = e.track
                  , n = c();
                o = v(n);
                var g = e.track.details
                  , m = [];
                if (n || !t) {
                    var f = h(n)
                      , b = f.dist
                      , y = f.dur;
                    if (y *= 2,
                    b *= o,
                    t) {
                        var S = i.idxToDist(i.distToIdx(b), !0);
                        S && (b = S)
                    }
                    m.push({
                        distance: b,
                        duration: y,
                        easing: d
                    });
                    var w = g.position
                      , k = w + b;
                    if (k < r || k > a) {
                        var E = k < r ? r - w : a - w
                          , x = 0
                          , D = n;
                        if (v(E) === o) {
                            var I = Math.min(Math.abs(E) / Math.abs(b), 1)
                              , T = (1 - Math.pow(1 - I, 1 / 3)) * y;
                            m[0].earlyExit = T,
                            D = n * (1 - I)
                        } else
                            m[0].earlyExit = 0,
                            x += E;
                        var C = h(D, 100)
                          , A = C.dist * o;
                        e.options.rubberband && (m.push({
                            distance: A,
                            duration: 2 * C.dur,
                            easing: d
                        }),
                        m.push({
                            distance: -A + x,
                            duration: 500,
                            easing: d
                        }))
                    }
                    e.animator.start(m)
                } else
                    e.moveToIdx(u(g.abs, l, s), !0, {
                        duration: 500,
                        easing: function(e) {
                            return 1 + --e * e * e * e * e
                        }
                    })
            }()
        }),
        e.on("dragged", function() {
            i = e.track.details.abs
        })
    }
    function m(e) {
        var t, i, n, o, r, c, h, g, p, m, f, b, y, S, w, k, E, x, D = d();
        function I(t) {
            if (c && g === t.id) {
                var a = B(t);
                if (p) {
                    if (!A(t))
                        return C(t);
                    m = a,
                    p = !1,
                    e.emit("dragChecked")
                }
                if (k)
                    return m = a;
                l(t);
                var d = function(t) {
                    if (E === -1 / 0 && x === 1 / 0)
                        return t;
                    var n = e.track.details
                      , a = n.length
                      , l = n.position
                      , s = u(t, E - l, x - l);
                    if (0 === a)
                        return 0;
                    if (!e.options.rubberband)
                        return s;
                    if (l <= x && l >= E || l < E && i > 0 || l > x && i < 0)
                        return t;
                    var d = Math.max(0, 1 - Math.abs((l < E ? l - E : l - x) / a * (o * a)) / r * 2);
                    return d * d * t
                }(h(m - a) / o * n);
                i = v(d);
                var y = e.track.details.position;
                (y > E && y < x || y === E && i > 0 || y === x && i < 0) && s(t),
                f += d,
                !b && Math.abs(f * o) > 5 && (b = !0),
                e.track.add(d),
                m = a,
                e.emit("dragged")
            }
        }
        function T(t) {
            !c && e.track.details && e.track.details.length && (f = 0,
            c = !0,
            b = !1,
            p = !0,
            g = t.id,
            A(t),
            m = B(t),
            e.emit("dragStarted"))
        }
        function C(t) {
            c && g === t.idChanged && (c = !1,
            e.emit("dragEnded"))
        }
        function A(e) {
            var t = L()
              , i = t ? e.y : e.x
              , n = t ? e.x : e.y
              , o = void 0 !== y && void 0 !== S && Math.abs(S - n) <= Math.abs(y - i);
            return y = i,
            S = n,
            o
        }
        function B(e) {
            return L() ? e.y : e.x
        }
        function L() {
            return e.options.vertical
        }
        function M() {
            o = e.size,
            r = L() ? window.innerHeight : window.innerWidth;
            var t = e.track.details;
            t && (E = t.min,
            x = t.max)
        }
        function O(e) {
            b && (s(e),
            l(e))
        }
        function N() {
            if (D.purge(),
            e.options.drag && !e.options.disabled) {
                h = "function" == typeof (o = e.options.dragSpeed || 1) ? o : function(e) {
                    return e * o
                }
                ,
                n = e.options.rtl ? -1 : 1,
                M(),
                t = e.container,
                i = "data-keen-slider-clickable",
                a("[".concat(i, "]:not([").concat(i, "=false])"), t).map(function(e) {
                    D.add(e, "dragstart", s),
                    D.add(e, "mousedown", s),
                    D.add(e, "touchstart", s)
                }),
                D.add(t, "dragstart", function(e) {
                    l(e)
                }),
                D.add(t, "click", O, {
                    capture: !0
                }),
                D.input(t, "ksDragStart", T),
                D.input(t, "ksDrag", I),
                D.input(t, "ksDragEnd", C),
                D.input(t, "mousedown", T),
                D.input(t, "mousemove", I),
                D.input(t, "mouseleave", C),
                D.input(t, "mouseup", C),
                D.input(t, "touchstart", T, {
                    passive: !0
                }),
                D.input(t, "touchmove", I, {
                    passive: !1
                }),
                D.input(t, "touchend", C),
                D.input(t, "touchcancel", C),
                D.add(window, "wheel", function(e) {
                    c && l(e)
                });
                var i, o, r = "data-keen-slider-scrollable";
                a("[".concat(r, "]:not([").concat(r, "=false])"), e.container).map(function(e) {
                    var t;
                    D.input(e, "touchstart", function(e) {
                        t = B(e),
                        k = !0,
                        w = !0
                    }, {
                        passive: !0
                    }),
                    D.input(e, "touchmove", function(i) {
                        var n = L()
                          , o = n ? e.scrollHeight - e.clientHeight : e.scrollWidth - e.clientWidth
                          , r = t - B(i)
                          , a = n ? e.scrollTop : e.scrollLeft
                          , s = n && "scroll" === e.style.overflowY || !n && "scroll" === e.style.overflowX;
                        if (t = B(i),
                        (r < 0 && a > 0 || r > 0 && a < o) && w && s)
                            return k = !0;
                        w = !1,
                        l(i),
                        k = !1
                    }),
                    D.input(e, "touchend", function() {
                        k = !1
                    })
                })
            }
        }
        e.on("updated", M),
        e.on("optionsChanged", N),
        e.on("created", N),
        e.on("destroyed", D.purge)
    }
    function f(e) {
        var t, i, n = null;
        function o(t, i, n) {
            e.animator.active ? a(t, i, n) : requestAnimationFrame(function() {
                return a(t, i, n)
            })
        }
        function r() {
            o(!1, !1, i)
        }
        function a(i, o, r) {
            var a = 0
              , l = e.size
              , u = e.track.details;
            if (u && t) {
                var v = u.slides;
                t.forEach(function(e, t) {
                    if (i)
                        !n && o && s(e, null, r),
                        d(e, null, r);
                    else {
                        if (!v[t])
                            return;
                        var u = v[t].size * l;
                        !n && o && s(e, u, r),
                        d(e, v[t].distance * l - a, r),
                        a += u
                    }
                })
            }
        }
        function l(t) {
            return "performance" === e.options.renderMode ? Math.round(t) : t
        }
        function s(e, t, i) {
            var n = i ? "height" : "width";
            null !== t && (t = l(t) + "px"),
            e.style["min-" + n] = t,
            e.style["max-" + n] = t
        }
        function d(e, t, i) {
            if (null !== t) {
                t = l(t);
                var n = i ? t : 0;
                t = "translate3d(".concat(i ? 0 : t, "px, ").concat(n, "px, 0)")
            }
            e.style.transform = t,
            e.style["-webkit-transform"] = t
        }
        function u() {
            t && (a(!0, !0, i),
            t = null),
            e.on("detailsChanged", r, !0)
        }
        function v() {
            o(!1, !0, i)
        }
        function c() {
            u(),
            i = e.options.vertical,
            e.options.disabled || "custom" === e.options.renderMode || (n = "auto" === h(e.options.slides, "perView", null),
            e.on("detailsChanged", r),
            (t = e.slides).length && v())
        }
        e.on("created", c),
        e.on("optionsChanged", c),
        e.on("beforeOptionsChanged", function() {
            u()
        }),
        e.on("updated", v),
        e.on("destroyed", u)
    }
    "function" == typeof SuppressedError && SuppressedError;
    var b = function(i, n, l) {
        try {
            var s, b, y, S;
            return b = t([(s = {
                drag: !0,
                mode: "snap",
                renderMode: "precision",
                rubberband: !0,
                selector: ".keen-slider__slide"
            },
            function(t) {
                var n, o, l, u, v, g = d();
                function p(e) {
                    var i;
                    r(t.container, "reverse", "rtl" !== (i = t.container,
                    window.getComputedStyle(i, null).getPropertyValue("direction")) || e ? null : ""),
                    r(t.container, "v", t.options.vertical && !e ? "" : null),
                    r(t.container, "disabled", t.options.disabled && !e ? "" : null)
                }
                function m() {
                    f() && w()
                }
                function f() {
                    var i = null;
                    if (u.forEach(function(e) {
                        e.matches && (i = e.__media)
                    }),
                    i === n)
                        return !1;
                    n || t.emit("beforeOptionsChanged"),
                    n = i;
                    var o = i ? l.breakpoints[i] : l;
                    return t.options = e(e({}, l), o),
                    p(),
                    I(),
                    T(),
                    E(),
                    !0
                }
                function b() {
                    return t.options.trackConfig.length
                }
                function y(i) {
                    for (var r in n = !1,
                    l = e(e({}, s), i),
                    g.purge(),
                    o = t.size,
                    u = [],
                    l.breakpoints || []) {
                        var a = window.matchMedia(r);
                        a.__media = r,
                        u.push(a),
                        g.add(a, "change", m)
                    }
                    g.add(window, "orientationchange", D),
                    g.add(window, "resize", x),
                    f()
                }
                function S(e) {
                    t.animator.stop();
                    var i = t.track.details;
                    t.track.init(null != e ? e : i ? i.abs : 0)
                }
                function w(e) {
                    S(e),
                    t.emit("optionsChanged")
                }
                function k(e, i) {
                    if (e)
                        return y(e),
                        void w(i);
                    I(),
                    T();
                    var n = b();
                    E(),
                    b() !== n ? w(i) : S(i),
                    t.emit("updated")
                }
                function E() {
                    var e = t.options.slides;
                    if ("function" == typeof e)
                        return t.options.trackConfig = e(t.size, t.slides);
                    var i = t.slides
                      , n = i.length
                      , o = "number" == typeof e ? e : h(e, "number", n, !0)
                      , r = []
                      , a = h(e, "perView", 1, !0)
                      , l = "number" == typeof a ? h(e, "numberOfFullWidthShow", void 0, !0) : a
                      , s = h(e, "spacing", 0, !0) / t.size || 0
                      , d = "auto" === a ? s : s / a
                      , u = 0;
                    "number" == typeof l && (u = s * (Math.floor(l) - 1));
                    for (var v = h(e, "origin", "auto"), g = 0, p = 0; p < o; p++) {
                        var m = "auto" === a ? function(e) {
                            var i = c(e);
                            return (t.options.vertical ? i.height : i.width) / t.size || 1
                        }(i[p]) - s + d : 1 / a - s + d
                          , f = "center" === v ? "number" == typeof l ? .5 - u / 2 - Math.floor(l) * m / 2 : .5 - m / 2 : "auto" === v ? 0 : v;
                        r.push({
                            origin: f,
                            size: m,
                            spacing: s
                        }),
                        g += m
                    }
                    if (g += s * (o - 1),
                    "auto" === v && !t.options.loop && 1 !== a) {
                        var b = 0;
                        r.map(function(e) {
                            var t = g - b;
                            return b += e.size + s,
                            t >= 1 || (e.origin = 1 - t - (g > 1 ? 0 : 1 - g)),
                            e
                        })
                    }
                    t.options.trackConfig = r
                }
                function x() {
                    I();
                    var e = t.size;
                    t.options.disabled || e === o || (o = e,
                    k())
                }
                function D() {
                    x(),
                    setTimeout(x, 500),
                    setTimeout(x, 2e3)
                }
                function I() {
                    var e = c(t.container);
                    t.size = (t.options.vertical ? e.height : e.width) || 1
                }
                function T() {
                    t.slides = a(t.options.selector, t.container)
                }
                t.container = (v = a(i, document)).length ? v[0] : null,
                t.destroy = function() {
                    g.purge(),
                    t.emit("destroyed"),
                    p(!0)
                }
                ,
                t.prev = function() {
                    t.moveToIdx(t.track.details.abs - 1, !0)
                }
                ,
                t.next = function() {
                    t.moveToIdx(t.track.details.abs + 1, !0)
                }
                ,
                t.update = k,
                y(t.options)
            }
            ), f, m, p], l || [], !0),
            S = {},
            y = {
                emit: function(e) {
                    S[e] && S[e].forEach(function(e) {
                        e(y)
                    });
                    var t = y.options && y.options[e];
                    t && t(y)
                },
                moveToIdx: function(e, t, i) {
                    var n = y.track.idxToDist(e, t);
                    if (n) {
                        var o = y.options.defaultAnimation;
                        y.animator.start([{
                            distance: n,
                            duration: h(i || o, "duration", 500),
                            easing: h(i || o, "easing", function(e) {
                                return 1 + --e * e * e * e * e
                            })
                        }])
                    }
                },
                on: function(e, t, i) {
                    void 0 === i && (i = !1),
                    S[e] || (S[e] = []);
                    var n = S[e].indexOf(t);
                    n > -1 ? i && delete S[e][n] : i || S[e].push(t)
                },
                options: n
            },
            function() {
                if (y.track = function(e) {
                    var i, n, r, a, l, s, d, c, p, m, f, b, y, S, w = 1 / 0, k = [], E = null, x = 0;
                    function D(e) {
                        M(x + e)
                    }
                    function I(e) {
                        var t = T(x + e).abs;
                        return B(t) === t ? t : null
                    }
                    function T(e) {
                        var i = Math.floor(Math.abs(g(e / n)))
                          , o = g((e % n + n) % n);
                        o === n && (o = 0);
                        var r = v(e)
                          , a = d.indexOf(t([], d).reduce(function(e, t) {
                            return Math.abs(t - o) < Math.abs(e - o) ? t : e
                        }))
                          , l = a;
                        return r < 0 && i++,
                        a === s && (l = 0,
                        i += r > 0 ? 1 : -1),
                        {
                            abs: l + i * s * r,
                            origin: a,
                            rel: l
                        }
                    }
                    function C(e, t, i) {
                        if (t || !a.loop)
                            return A(e, i);
                        if (B(e) !== e)
                            return null;
                        var n, o = T(null != i ? i : x), r = o.abs, l = e - o.rel, d = r + l;
                        n = A(d);
                        var u = A(d - s * v(l));
                        return (null !== u && Math.abs(u) < Math.abs(n) || null === n) && (n = u),
                        g(n)
                    }
                    function A(e, t) {
                        if (null == t && (t = g(x)),
                        i = e,
                        B(i) !== i || null === e)
                            return null;
                        e = Math.round(e);
                        var i, o = T(t), r = o.abs, a = o.rel, l = o.origin, u = L(e), v = (t % n + n) % n, c = d[l], h = Math.floor((e - (r - a)) / s) * n;
                        return g(c - v - c + d[u] + h + (l === s ? n : 0))
                    }
                    function B(e) {
                        return u(e, p, m)
                    }
                    function L(e) {
                        return (e % s + s) % s
                    }
                    function M(t) {
                        i = t - x,
                        k.push({
                            distance: i,
                            timestamp: o()
                        }),
                        k.length > 6 && (k = k.slice(-6)),
                        x = g(t);
                        var i, n = O().abs;
                        if (n !== E) {
                            var r = null !== E;
                            E = n,
                            r && e.emit("slideChanged")
                        }
                    }
                    function O(t) {
                        var o = t ? null : function() {
                            if (s) {
                                var e = a.loop
                                  , t = e ? (x % n + n) % n : x
                                  , i = (e ? x % n : x) - l[0][2]
                                  , o = 0 - (i < 0 && e ? n - Math.abs(i) : i)
                                  , d = 0
                                  , u = T(x)
                                  , c = u.abs
                                  , h = u.rel
                                  , g = l[h][2]
                                  , w = l.map(function(t, i) {
                                    var r = o + d;
                                    (r < 0 - t[0] || r > 1) && (r += (Math.abs(r) > n - 1 && e ? n : 0) * v(-r));
                                    var l = i - h
                                      , u = v(l)
                                      , p = l + c;
                                    e && (-1 === u && r > g && (p += s),
                                    1 === u && r < g && (p -= s),
                                    null !== f && p < f && (r += n),
                                    null !== b && p > b && (r -= n));
                                    var m = r + t[0] + t[1]
                                      , y = Math.max(r >= 0 && m <= 1 ? 1 : m < 0 || r > 1 ? 0 : r < 0 ? Math.min(1, (t[0] + r) / t[0]) : (1 - r) / t[0], 0);
                                    return d += t[0] + t[1],
                                    {
                                        abs: p,
                                        distance: a.rtl ? -1 * r + 1 - t[0] : r,
                                        portion: y,
                                        size: t[0]
                                    }
                                });
                                return h = L(c = B(c)),
                                {
                                    abs: B(c),
                                    length: r,
                                    max: S,
                                    maxIdx: m,
                                    min: y,
                                    minIdx: p,
                                    position: x,
                                    progress: e ? t / n : x / r,
                                    rel: h,
                                    slides: w,
                                    slidesLength: n
                                }
                            }
                        }();
                        return i.details = o,
                        e.emit("detailsChanged"),
                        o
                    }
                    return i = {
                        absToRel: L,
                        add: D,
                        details: null,
                        distToIdx: I,
                        idxToDist: C,
                        init: function(t) {
                            var i, o, u, v;
                            if (function() {
                                if (s = (l = ((a = e.options).trackConfig || []).map(function(e) {
                                    return [h(e, "size", 1), h(e, "spacing", 0), h(e, "origin", 0)]
                                })).length) {
                                    n = g(l.reduce(function(e, t) {
                                        return e + t[0] + t[1]
                                    }, 0));
                                    var t, i = s - 1;
                                    r = g(n + l[0][2] - l[i][0] - l[i][2] - l[i][1]),
                                    d = l.reduce(function(e, i) {
                                        if (!e)
                                            return [0];
                                        var n = l[e.length - 1]
                                          , o = e[e.length - 1] + (n[0] + n[2]) + n[1];
                                        return o -= i[2],
                                        e[e.length - 1] > o && (o = e[e.length - 1]),
                                        o = g(o),
                                        e.push(o),
                                        (!t || t < o) && (c = e.length - 1),
                                        t = o,
                                        e
                                    }, null),
                                    0 === r && (c = 0),
                                    d.push(g(n))
                                }
                            }(),
                            !s)
                                return O(!0);
                            i = e.options.range,
                            f = p = (o = e.options.loop) ? h(o, "min", -w) : 0,
                            b = m = o ? h(o, "max", w) : c,
                            u = h(i, "min", null),
                            v = h(i, "max", null),
                            null !== u && (p = u),
                            null !== v && (m = v),
                            y = p === -w ? p : e.track.idxToDist(p || 0, !0, 0),
                            S = m === w ? m : C(m, !0, 0),
                            null === v && (b = m),
                            h(i, "align", !1) && m !== w && 0 === l[L(m)][2] && (S -= 1 - l[L(m)][0],
                            m = I(S - x)),
                            y = g(y),
                            S = g(S),
                            Number(t) === t ? D(A(B(t))) : O()
                        },
                        to: M,
                        velocity: function() {
                            var e = o()
                              , t = k.reduce(function(t, i) {
                                var n = i.distance
                                  , o = i.timestamp;
                                return e - o > 200 || (v(n) !== v(t.distance) && t.distance && (t = {
                                    distance: 0,
                                    lastTimestamp: 0,
                                    time: 0
                                }),
                                t.time && (t.distance += n),
                                t.lastTimestamp && (t.time += o - t.lastTimestamp),
                                t.lastTimestamp = o),
                                t
                            }, {
                                distance: 0,
                                lastTimestamp: 0,
                                time: 0
                            });
                            return t.distance / t.time || 0
                        }
                    }
                }(y),
                y.animator = function(e) {
                    var t, i, n, o, r, a;
                    function l(e) {
                        t.active = e
                    }
                    function s(e) {
                        t.targetIdx = e
                    }
                    function d() {
                        var t;
                        t = r,
                        window.cancelAnimationFrame(t),
                        l(!1),
                        s(null),
                        a && e.emit("animationStopped"),
                        a = null
                    }
                    return t = {
                        active: !1,
                        start: function(t) {
                            if (d(),
                            e.track.details) {
                                var u = 0
                                  , v = e.track.details.position;
                                i = 0,
                                n = 0,
                                o = t.map(function(e) {
                                    var t, i = Number(v), o = null !== (t = e.earlyExit) && void 0 !== t ? t : e.duration, r = e.easing, a = e.distance * r(o / e.duration) || 0;
                                    v += a;
                                    var l = n;
                                    return n += o,
                                    u += a,
                                    [i, e.distance, l, n, e.duration, r]
                                }),
                                s(e.track.distToIdx(u)),
                                function t() {
                                    r = window.requestAnimationFrame(function r(d) {
                                        a || (a = d),
                                        l(!0);
                                        var u = d - a;
                                        u > n && (u = n);
                                        var v = o[i];
                                        if (v[3] < u)
                                            return i++,
                                            r(d);
                                        var c = v[2]
                                          , h = v[4]
                                          , g = v[0]
                                          , p = v[1] * (0,
                                        v[5])(0 === h ? 1 : (u - c) / h);
                                        if (p && e.track.to(g + p),
                                        u < n)
                                            return t();
                                        a = null,
                                        l(!1),
                                        s(null),
                                        e.emit("animationEnded")
                                    })
                                }(),
                                e.emit("animationStarted")
                            }
                        },
                        stop: d,
                        targetIdx: null
                    }
                }(y),
                b)
                    for (var e = 0; e < b.length; e++)
                        (0,
                        b[e])(y);
                y.track.init(y.options.initial || 0),
                y.emit("created")
            }(),
            y
        } catch (e) {
            console.error(e)
        }
    };
    let y = e => {
        var t, i, n, o;
        let r;
        let a = null !== (o = e.options.autoplay) && void 0 !== o ? o : {}
          , l = !1
          , s = null
          , d = null === (n = e.container) || void 0 === n ? void 0 : null === (i = n.closest(".gp-carousel-wrapper")) || void 0 === i ? void 0 : null === (t = i.getElementsByClassName("gp-carousel-dot-container")) || void 0 === t ? void 0 : t[0];
        function u(e) {
            e.forEach(e => {
                e.isIntersecting ? c() : v()
            }
            )
        }
        function v() {
            clearTimeout(r)
        }
        function c() {
            var t, i;
            clearTimeout(r),
            r = setTimeout( () => {
                !l && a.enable && e.next()
            }
            , null !== (i = null === (t = a) || void 0 === t ? void 0 : t.delay) && void 0 !== i ? i : 2e3)
        }
        function h() {
            l = !0,
            v()
        }
        function g() {
            l = !1,
            c()
        }
        e.on("created", () => {
            var t;
            null == d || d.addEventListener("mouseover", h),
            null == d || d.addEventListener("mouseout", g),
            a.pauseOnHover && (e.container.addEventListener("mouseover", h),
            e.container.addEventListener("mouseout", g)),
            (null === (t = e.options.autoplay) || void 0 === t ? void 0 : t.enable) && c()
        }
        ),
        e.on("dragStarted", v),
        e.on("animationEnded", c),
        e.on("updated", e => {
            var t, i;
            a = null !== (i = null === (t = e.options) || void 0 === t ? void 0 : t.autoplay) && void 0 !== i ? i : {},
            c()
        }
        ),
        e.on("destroyed", () => {
            e.container.removeEventListener("mouseover", h),
            e.container.removeEventListener("mouseout", g)
        }
        ),
        e.on("optionsChanged", t => {
            var i, n, o, r;
            (null === (i = t.options.autoplay) || void 0 === i ? void 0 : i.pauseOnHover) === a.pauseOnHover || ((null === (n = t.options.autoplay) || void 0 === n ? void 0 : n.pauseOnHover) && (e.container.addEventListener("mouseover", h),
            e.container.addEventListener("mouseout", g)),
            (null === (o = t.options.autoplay) || void 0 === o ? void 0 : o.pauseOnHover) || (e.container.removeEventListener("mouseover", h),
            e.container.removeEventListener("mouseout", g),
            l = !1)),
            c(),
            (a = null !== (r = t.options.autoplay) && void 0 !== r ? r : {}).enable && (s || !e.container || (s = new IntersectionObserver(u,{
                root: null,
                threshold: 0
            })).observe(e.container),
            c())
        }
        ),
        e.on("destroyed", () => {
            e.container && (e.container.removeEventListener("mouseover", h),
            e.container.removeEventListener("mouseout", g)),
            null == d || d.removeEventListener("mouseover", h),
            null == d || d.removeEventListener("mouseout", g),
            v(),
            s && (s.disconnect(),
            s = null)
        }
        )
    }
      , S = e => {
        let t = new MutationObserver(t => {
            t.forEach( () => {
                e.update()
            }
            )
        }
        )
          , i = {
            childList: !0
        }
          , n = new ResizeObserver(function() {
            o(e),
            e.update()
        }
        )
          , o = e => {
            if (e.options.vertical) {
                r(e);
                return
            }
            a(e)
        }
          , r = e => {
            e.slides.forEach(e => {
                e && (e.style.maxWidth = "",
                e.style.minWidth = "")
            }
            )
        }
          , a = e => {
            e.slides.forEach(e => {
                e && (e.style.maxHeight = "",
                e.style.minHeight = "")
            }
            )
        }
        ;
        e.on("created", () => {
            n.observe(e.container),
            t.observe(e.container, i)
        }
        ),
        e.on("destroyed", () => {
            n.unobserve(e.container),
            t.disconnect()
        }
        )
    }
      , w = e => {
        if (e)
            return e && "string" == typeof e && ((null == e ? void 0 : e.toLowerCase().startsWith("#")) || (null == e ? void 0 : e.toLowerCase().startsWith("rgb")) || (null == e ? void 0 : e.toLowerCase().startsWith("hsl")) || (null == e ? void 0 : e.toLowerCase().startsWith("transparent"))) ? e : `var(--g-c-${e}, ${e})`
    }
      , k = ["desktop", "tablet", "mobile"]
      , E = {
        DESKTOP: "desktop",
        TABLET: "tablet",
        MOBILE: "mobile"
    }
      , x = (e, t, i) => {
        var n, o, r, a, l, s;
        switch (t) {
        case E.TABLET:
            return null !== (o = null !== (n = null == e ? void 0 : e.tablet) && void 0 !== n ? n : null == e ? void 0 : e.desktop) && void 0 !== o ? o : i;
        case E.MOBILE:
            return null !== (l = null !== (a = null !== (r = null == e ? void 0 : e.mobile) && void 0 !== r ? r : null == e ? void 0 : e.tablet) && void 0 !== a ? a : null == e ? void 0 : e.desktop) && void 0 !== l ? l : i;
        default:
            return null !== (s = null == e ? void 0 : e.desktop) && void 0 !== s ? s : i
        }
    }
      , D = (e, t, i) => {
        let n = e.getAttribute("gp-data-interaction")
          , o = JSON.parse(n || "{}");
        e.setAttribute("gp-data-interaction", JSON.stringify({
            ...o,
            [t]: i
        }))
    }
    ;
    function I(e, t, i) {
        return t in e ? Object.defineProperty(e, t, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = i,
        e
    }
    let T = {
        EASE_IN: {
            value: "ease-in",
            formula: e => e * e * e
        },
        EASE_OUT: {
            value: "ease-out",
            formula: e => 1 - Math.pow(1 - e, 3)
        },
        EASE_IN_OUT: {
            value: "ease-in-out",
            formula: e => e < .5 ? 4 * e * e * e : 1 - Math.pow(-2 * e + 2, 3) / 2
        },
        DEFAULT: {
            value: "default",
            formula: e => 1 + --e * e * e * e * e
        }
    }
      , C = "gem-slider-item"
      , A = "gp-carousel-dot"
      , B = "gp-carousel-dot--active"
      , L = "var(--g-c-highlight, highlight)"
      , M = "var(--g-c-bg-1, bg-1);"
      , O = () => {
        window.removeEventListener("gp-global-loaded", O),
        customElements.get("gp-carousel") || customElements.define("gp-carousel", class extends GP.Component {
            connectedCallback() {
                this.init()
            }
            dispatchEventSelectItem(e) {
                this.trigger && (this.trigger({
                    event: "gp:rollback:select-slide"
                }),
                this.trigger({
                    event: "gp:select-slide",
                    data: e
                }))
            }
            nextToIndex(e) {
                var t;
                null === (t = this.slider) || void 0 === t || t.moveToIdx(e, !0, {
                    duration: 0
                }),
                this.previousIndex = e
            }
            moveToIdx(e) {
                var t, i, n, o;
                let {maxIdx: r=0} = null !== (o = null === (i = this.slider) || void 0 === i ? void 0 : null === (t = i.track) || void 0 === t ? void 0 : t.details) && void 0 !== o ? o : {}
                  , a = e > r ? r : e;
                null === (n = this.slider) || void 0 === n || n.moveToIdx(a)
            }
            nextSlide(e) {
                let {key: t, isRollback: i, element: n} = e;
                if (i) {
                    this.moveToIdx(this.previousIndex - 1);
                    return
                }
                D(n, t, String(this.previousIndex)),
                this.moveToIdx(this.previousIndex + 1)
            }
            changeIndexSlideInteraction(e) {
                let {rel: t} = this.getSliderSetting()
                  , {key: i, data: n, isRollback: o, element: r} = e;
                if (o) {
                    this.moveToIdx(Number(n));
                    return
                }
                D(r, i, String(t)),
                this.moveToIdx(n)
            }
            previousSlide(e) {
                let {key: t, isRollback: i, element: n} = e;
                if (i) {
                    this.moveToIdx(this.previousIndex + 1);
                    return
                }
                D(n, t, String(this.previousIndex)),
                this.moveToIdx(this.previousIndex - 1)
            }
            getSliderOption() {
                var e, t, i, n, o, r, a, l, s, d, u;
                let v = this.getSlideToShow()
                  , c = window.screenSize.isMobile()
                  , h = `#gp-carousel-${this.componentId}>.${C}`
                  , g = e => {
                    var t, i, n, o;
                    return {
                        slides: {
                            perView: x(v, e, 4) || 1,
                            spacing: x(null === (t = this.styles) || void 0 === t ? void 0 : t.spacing, e),
                            origin: this.getOriginCarousel(e),
                            numberOfFullWidthShow: this.getNumberOfFullWidthShow(e)
                        },
                        loop: x(null === (i = this.setting) || void 0 === i ? void 0 : i.loop, e, !1),
                        vertical: x(null === (n = this.setting) || void 0 === n ? void 0 : n.vertical, e),
                        range: this.getMaxNavigationWhenSneak(e),
                        drag: x(null === (o = this.setting) || void 0 === o ? void 0 : o.enableDrag, e, !1)
                    }
                }
                  , p = window.screenSize.isMobile() ? null !== (d = null !== (s = null == v ? void 0 : v.mobile) && void 0 !== s ? s : null == v ? void 0 : v.tablet) && void 0 !== d ? d : null == v ? void 0 : v.desktop : window.screenSize.isTablet() && null !== (u = null == v ? void 0 : v.tablet) && void 0 !== u ? u : null == v ? void 0 : v.desktop
                  , m = p ? {
                    "(max-width: 9999px)": g("desktop"),
                    "(max-width: 1024px)": g("tablet"),
                    "(max-width: 767px)": g("mobile")
                } : {};
                return {
                    selector: h,
                    initial: this.getState("moveToIdx") || 0,
                    defaultAnimation: {
                        duration: null !== (a = null === (e = this.styles) || void 0 === e ? void 0 : e.playSpeed) && void 0 !== a ? a : 500,
                        easing: e => {
                            var t;
                            switch (null === (t = this.setting) || void 0 === t ? void 0 : t.animationMode) {
                            case T.EASE_IN.value:
                                return T.EASE_IN.formula(e);
                            case T.EASE_OUT.value:
                                return T.EASE_OUT.formula(e);
                            case T.EASE_IN_OUT.value:
                                return T.EASE_IN_OUT.formula(e);
                            default:
                                return T.DEFAULT.formula(e)
                            }
                        }
                    },
                    dragSpeed: 1,
                    renderMode: "performance",
                    mode: "snap",
                    loop: this.getValueByDevice(this.loop, E.DESKTOP, !1),
                    vertical: this.getValueByDevice(null === (t = this.setting) || void 0 === t ? void 0 : t.vertical, E.DESKTOP, !1),
                    drag: this.getValueByDevice(this.enableDrag, E.DESKTOP, !1),
                    rtl: null === (i = this.setting) || void 0 === i ? void 0 : i.rtl,
                    breakpoints: m,
                    autoplay: {
                        delay: (null !== (l = null === (n = this.setting) || void 0 === n ? void 0 : n.autoplayTimeout) && void 0 !== l ? l : 1) * 1e3,
                        pauseOnHover: null === (o = this.setting) || void 0 === o ? void 0 : o.pauseOnHover,
                        enable: null === (r = this.setting) || void 0 === r ? void 0 : r.autoplay
                    },
                    created: e => {
                        this.onCreated(e)
                    }
                    ,
                    updated: () => {
                        if (this.productFormID && !this.isUpdated) {
                            let e = new CustomEvent("activeMoveIndexSlider-" + this.productFormID);
                            window.dispatchEvent(e),
                            this.isUpdated = !0
                        }
                    }
                    ,
                    slideChanged: e => {
                        let t = 0;
                        t = this.productMedia > 0 ? e.track.details.rel % this.productMedia : e.track.details.rel,
                        this.setAttribute("active-index", t.toString()),
                        this.previousIndex = t;
                        let i = new Event("changeActiveIndex");
                        this.dispatchEvent(i)
                    }
                    ,
                    dragStarted: c ? void 0 : e => {
                        e.container.style.cursor = "grabbing"
                    }
                    ,
                    dragEnded: c ? void 0 : e => {
                        e.container.style.cursor = "auto"
                    }
                    ,
                    animationStarted: c ? void 0 : e => {
                        this.isRunningAnimation ? e.options.defaultAnimation = {
                            duration: 500,
                            easing: e => T.DEFAULT.formula(e)
                        } : this.isRunningAnimation = !0
                    }
                    ,
                    animationEnded: c ? void 0 : e => {
                        var t, i, n;
                        let o = null === (t = this.setting) || void 0 === t ? void 0 : t.animationMode;
                        this.isRunningAnimation = !1,
                        e.options.defaultAnimation = {
                            duration: (null === (i = this.styles) || void 0 === i ? void 0 : i.playSpeed) === 0 ? 1 : (null === (n = this.styles) || void 0 === n ? void 0 : n.playSpeed) || 500,
                            easing(e) {
                                switch (o) {
                                case T.EASE_IN.value:
                                    return T.EASE_IN.formula(e);
                                case T.EASE_OUT.value:
                                    return T.EASE_OUT.formula(e);
                                case T.EASE_IN_OUT.value:
                                    return T.EASE_IN_OUT.formula(e);
                                default:
                                    return T.DEFAULT.formula(e)
                                }
                            }
                        }
                    }
                }
            }
            onCreated(e) {
                this.setSlider(e),
                this.getBackAndNextButton(),
                this.getDotContainer(),
                this.initSliderEvent(),
                this.updateDotClickEvent(),
                this.renderSliderDots(),
                this.checkDisableArrowButton(),
                this.showWrapper()
            }
            setSlider(e) {
                this.slider = e
            }
            getBackAndNextButton() {
                var e, t;
                this.nextButton = null === (e = this.getElementsByClassName(`gp-carousel-action-next ${this.componentId}`)) || void 0 === e ? void 0 : e[0],
                this.backButton = null === (t = this.getElementsByClassName(`gp-carousel-action-back ${this.componentId}`)) || void 0 === t ? void 0 : t[0]
            }
            getDotContainer() {
                var e;
                this.dotContainer = null === (e = this.getElementsByClassName(`gp-carousel-dot-container-${this.componentId}`)) || void 0 === e ? void 0 : e[0]
            }
            initSliderEvent() {
                this.addEventNextAndBackSlide(),
                this.addEventSlideChange(),
                this.addEventAnimationEnded(),
                this.addEventOptionsChange()
            }
            addEventLazyImage() {
                let e = this
                  , t = this.querySelectorAll(`#gp-carousel-${this.componentId} .gem-slider-item`);
                t && e && t.forEach(t => {
                    let i = new IntersectionObserver(e => {
                        e.forEach(e => {
                            if (e.isIntersecting) {
                                let r = e.target.querySelector("img:not(.image-zoom)");
                                if (r && !r.classList.contains("gp_lazyload") && !r.classList.contains("gp_lazyloaded")) {
                                    var t, n, o;
                                    r.classList.add("gp_lazyload"),
                                    null === (o = window) || void 0 === o || null === (n = o.gpLazySizes) || void 0 === n || null === (t = n.loader) || void 0 === t || t.unveil(r)
                                }
                                i.disconnect()
                            }
                        }
                        )
                    }
                    ,{
                        root: e,
                        rootMargin: "100%"
                    });
                    i.observe(t)
                }
                )
            }
            addEventNextAndBackSlide() {
                var e, t;
                null === (e = this.nextButton) || void 0 === e || e.addEventListener("click", e => {
                    var t;
                    e.preventDefault(),
                    null === (t = this.slider) || void 0 === t || t.next()
                }
                ),
                null === (t = this.backButton) || void 0 === t || t.addEventListener("click", e => {
                    var t;
                    e.preventDefault(),
                    null === (t = this.slider) || void 0 === t || t.prev()
                }
                )
            }
            addEventSlideChange() {
                var e;
                null === (e = this.slider) || void 0 === e || e.on("slideChanged", e => {
                    this.setSlider(e),
                    this.checkDisableArrowButton(),
                    setTimeout( () => {
                        this.updateDotColor()
                    }
                    , 10)
                }
                )
            }
            checkDisableArrowButton() {
                var e, t, i, n, o, r;
                let a = null === (e = this.slider) || void 0 === e ? void 0 : e.options.loop;
                if (a)
                    return;
                let {abs: l=0, maxIdx: s=0} = null !== (r = null === (i = this.slider) || void 0 === i ? void 0 : null === (t = i.track) || void 0 === t ? void 0 : t.details) && void 0 !== r ? r : {}
                  , d = this.getValueByDevice(null === (n = this.setting) || void 0 === n ? void 0 : n.navigationEnable, window.screenSize.getDeviceName(), !0)
                  , u = this.getValueByDevice(null === (o = this.setting) || void 0 === o ? void 0 : o.navigationStyle, window.screenSize.getDeviceName(), "none");
                if ("none" !== u && d) {
                    if (s === 1 / 0)
                        return;
                    this.checkDisabledForBackButton(l),
                    this.checkDisabledForNextButton(l, s)
                }
            }
            checkDisabledForBackButton(e) {
                if (this.backButton) {
                    if (0 === e) {
                        this.disableArrowButton(this.backButton);
                        return
                    }
                    this.enableArrowButton(this.backButton)
                }
            }
            checkDisabledForNextButton(e, t) {
                if (this.nextButton) {
                    if (e === t) {
                        this.disableArrowButton(this.nextButton);
                        return
                    }
                    this.enableArrowButton(this.nextButton)
                }
            }
            disableArrowButton(e) {
                !1 !== this.isHiddenArrowWhenDisabled && (e.style.setProperty("visibility", "hidden", "important"),
                e.dataset.hidden = "true"),
                e.disabled = !0
            }
            enableArrowButton(e) {
                !1 !== this.isHiddenArrowWhenDisabled && (e.style.removeProperty("visibility"),
                e.dataset.hidden = "false"),
                e.disabled = !1
            }
            addEventAnimationEnded() {
                var e;
                null === (e = this.slider) || void 0 === e || e.on("animationEnded", e => {
                    this.setSlider(e)
                }
                )
            }
            updateDotColor() {
                var e, t, i, n, o;
                let {isInfinity: r, rel: a, slidePerPage: l} = this.getSliderSetting()
                  , s = this.getActiveIndexDot(r, a, l)
                  , d = null === (t = this.dotContainer) || void 0 === t ? void 0 : null === (e = t.getElementsByClassName(`${B}`)) || void 0 === e ? void 0 : e[0];
                if (!d)
                    return;
                let u = (null === (i = d.dataset) || void 0 === i ? void 0 : i.index) ? parseInt(null === (n = d.dataset) || void 0 === n ? void 0 : n.index, 10) : void 0;
                if (u === s)
                    return;
                let {activeBgc: v, inactiveBgc: c} = this.getDotBackgroundColorFrom(d);
                d.style.backgroundColor = c || M,
                d.classList.remove(B);
                let h = null === (o = this.dotContainer) || void 0 === o ? void 0 : o.querySelector(`#gp-carousel-${this.componentId}-${s}`);
                h && (h.style.backgroundColor = v || L,
                h.classList.add(B))
            }
            getDotBackgroundColorFrom(e) {
                let t = e.previousElementSibling
                  , i = "";
                if (t)
                    i = t.style.backgroundColor;
                else {
                    var n;
                    let t = e.nextElementSibling;
                    i = (null === (n = t.style) || void 0 === n ? void 0 : n.backgroundColor) || ""
                }
                let o = e.style.backgroundColor;
                return {
                    activeBgc: o,
                    inactiveBgc: i
                }
            }
            addEventOptionsChange() {
                var e;
                null === (e = this.slider) || void 0 === e || e.on("optionsChanged", e => {
                    this.setSlider(e),
                    this.updateDotClickEvent(),
                    this.renderSliderDots(),
                    this.checkDisableArrowButton()
                }
                )
            }
            updateDotClickEvent() {
                this.dotContainer && this.dotContainer.addEventListener("click", e => {
                    e.preventDefault();
                    let t = e.target;
                    !t.classList.contains(A) || t.classList.contains(B) || (this.changeStyleForDots(t),
                    this.goToSlideByIndex(this.getSlideIndexByDot(t)))
                }
                )
            }
            changeStyleForDots(e) {
                var t, i;
                let n = null === (i = this.dotContainer) || void 0 === i ? void 0 : null === (t = i.getElementsByClassName(`${B}`)) || void 0 === t ? void 0 : t[0];
                if (!n)
                    return;
                let o = n.style.backgroundColor
                  , r = e.style.backgroundColor;
                e.style.backgroundColor = o,
                e.classList.add(B),
                n.style.backgroundColor = r,
                n.classList.remove(B)
            }
            getSlideIndexByDot(e) {
                var t;
                return (null === (t = e.dataset) || void 0 === t ? void 0 : t.index) ? parseInt(e.dataset.index, 10) : void 0
            }
            goToSlideByIndex(e) {
                var t, i;
                if (void 0 === e)
                    return;
                let n = this.getValueByDevice(this.loop, window.screenSize.getDeviceName(), !1) ? e : this.getIndexSlideItem(e);
                x(null === (t = this.setting) || void 0 === t ? void 0 : t.sneakPeak, window.screenSize.getDeviceName()) && (n = e),
                this.previousIndex = n,
                null === (i = this.slider) || void 0 === i || i.moveToIdx(n)
            }
            getIndexSlideItem(e) {
                var t, i;
                let n = null !== (i = null === (t = this.slider) || void 0 === t ? void 0 : t.slides.length) && void 0 !== i ? i : 0
                  , o = this.getSlideToShow()
                  , r = this.getValueByDevice(o, window.screenSize.getDeviceName(), 4)
                  , a = e * r;
                return a >= n - r && (a = n - r),
                a
            }
            renderSliderDots(e=!1) {
                var t, i;
                let {isInfinity: n, rel: o, slidePerPage: r} = this.getSliderSetting()
                  , a = this.getValueByDevice(null === (t = this.setting) || void 0 === t ? void 0 : t.dot, window.screenSize.getDeviceName(), !0)
                  , l = this.getValueByDevice(null === (i = this.setting) || void 0 === i ? void 0 : i.dotStyle, window.screenSize.getDeviceName(), "none");
                if ("none" === l || !a)
                    return;
                let s = e ? [0] : this.getDotItems();
                if (!this.dotContainer || 0 === s.length)
                    return;
                let d = "";
                s.forEach(e => {
                    let t = this.getActiveIndexDot(n, o, r)
                      , i = e === t;
                    d += this.renderDot({
                        idx: e,
                        isActive: i
                    })
                }
                ),
                this.dotContainer.innerHTML = d
            }
            renderDot(e) {
                var t, i, n;
                let {idx: o, isActive: r} = e
                  , a = r ? null === (t = this.setting) || void 0 === t ? void 0 : t.dotActiveColor : null === (i = this.setting) || void 0 === i ? void 0 : i.dotColor
                  , l = r ? L : M;
                return `
            <button
              id="gp-carousel-${this.componentId}-${o}"
              data-index="${o}"
              aria-label="dot"
              style="background-color: ${a ? w(this.getValueByDevice(a, window.screenSize.getDeviceName(), void 0)) : l};
              aspect-ratio: 1/1;
              width: ${this.getValueByDevice(null === (n = this.setting) || void 0 === n ? void 0 : n.dotSize, window.screenSize.getDeviceName(), 12)}px;
              border-radius: 9999px;
              box-shadow: 0 4px 6px -1px rgba(0,0,0,.1);
              --tw-shadow: 0 2px 4px -2px rgba(0,0,0,.1);
              --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color),0 2px 4px -2px var(--tw-shadow-color);"
              class="${A} ${r ? `${B} gem-slider-dot-active` : "gem-slider-dot-inactive"}"
            >
            </button>
          `
            }
            getSliderSetting() {
                var e, t, i, n, o, r, a, l, s, d, u, v;
                let c = this.getSlideToShow();
                return {
                    isInfinity: (null === (i = this.slider) || void 0 === i ? void 0 : null === (t = i.track) || void 0 === t ? void 0 : null === (e = t.details) || void 0 === e ? void 0 : e.maxIdx) === 1 / 0,
                    slidePerPage: this.getValueByDevice(c, window.screenSize.getDeviceName(), 4),
                    totalSliderItem: null !== (u = null === (a = this.slider) || void 0 === a ? void 0 : null === (r = a.track) || void 0 === r ? void 0 : null === (o = r.details) || void 0 === o ? void 0 : null === (n = o.slides) || void 0 === n ? void 0 : n.length) && void 0 !== u ? u : 0,
                    rel: null !== (v = null === (d = this.slider) || void 0 === d ? void 0 : null === (s = d.track) || void 0 === s ? void 0 : null === (l = s.details) || void 0 === l ? void 0 : l.rel) && void 0 !== v ? v : 0
                }
            }
            getValueByDevice(e, t, i) {
                var n, o, r, a, l, s;
                let d = t || window.screenSize.getDeviceName();
                switch (d) {
                case E.MOBILE:
                    return null !== (r = null !== (o = null !== (n = null == e ? void 0 : e.mobile) && void 0 !== n ? n : null == e ? void 0 : e.tablet) && void 0 !== o ? o : null == e ? void 0 : e.desktop) && void 0 !== r ? r : i;
                case E.TABLET:
                    return null !== (l = null !== (a = null == e ? void 0 : e.tablet) && void 0 !== a ? a : null == e ? void 0 : e.desktop) && void 0 !== l ? l : i;
                default:
                    return null !== (s = null == e ? void 0 : e.desktop) && void 0 !== s ? s : i
                }
            }
            setWrapperHeight() {
                this.getSliderWrapper(),
                this.checkHeightAndAddEventResize()
            }
            setCarouselGap() {
                var e, t, i, n, o, r;
                this.sliderSelector = this.querySelector(`#gp-carousel-${this.componentId}`),
                this.sliderSelector && (null === (e = this.sliderSelector) || void 0 === e || e.style.removeProperty("--cg"),
                null === (t = this.sliderSelector) || void 0 === t || t.style.removeProperty("--cg-tablet"),
                null === (i = this.sliderSelector) || void 0 === i || i.style.removeProperty("--cg-mobile"),
                null === (n = this.sliderSelector) || void 0 === n || n.style.removeProperty("--rg"),
                null === (o = this.sliderSelector) || void 0 === o || o.style.removeProperty("--rg-tablet"),
                null === (r = this.sliderSelector) || void 0 === r || r.style.removeProperty("--rg-mobile"))
            }
            getSliderWrapper() {
                var e;
                this.sliderWrapper = null === (e = this.getElementsByClassName("gp-carousel-wrapper")) || void 0 === e ? void 0 : e[0]
            }
            getSliderSelector() {
                this.sliderSelector = this.querySelector(`#gp-carousel-${this.componentId}`)
            }
            setCarouselOffset() {
                let e = this.querySelector(`#gp-carousel-${this.componentId}>.${C}`);
                e && (null == e || e.style.removeProperty("--ml"),
                null == e || e.style.removeProperty("--ml-tablet"),
                null == e || e.style.removeProperty("--ml-mobile"))
            }
            showWrapper() {
                var e;
                let t = null === (e = this.getElementsByClassName("gp-carousel-wrapper")) || void 0 === e ? void 0 : e[0];
                t && (t.style.visibility = "")
            }
            checkHeightAndAddEventResize() {
                this.checkWrapperHeight(),
                window.addEventListener("resize", () => {
                    this.checkWrapperHeight()
                }
                )
            }
            checkWrapperHeight() {
                var e, t;
                let i = window.screenSize.getDeviceName();
                if (null === (e = null === (t = this.setting) || void 0 === t ? void 0 : t.vertical) || void 0 === e ? void 0 : e[i]) {
                    let e = this.getHeightByDevice(i);
                    if (!e || !this.sliderWrapper)
                        return;
                    this.sliderWrapper.style.height = e
                }
            }
            getHeightByDevice(e) {
                var t, i, n, o, r, a, l;
                let s = null === (t = this.styles) || void 0 === t ? void 0 : t.sizeSetting;
                switch (e) {
                case E.DESKTOP:
                    return null == s ? void 0 : null === (i = s.desktop) || void 0 === i ? void 0 : i.height;
                case E.TABLET:
                    return (null == s ? void 0 : null === (n = s.tablet) || void 0 === n ? void 0 : n.height) || (null == s ? void 0 : null === (o = s.desktop) || void 0 === o ? void 0 : o.height);
                case E.MOBILE:
                    return (null == s ? void 0 : null === (r = s.mobile) || void 0 === r ? void 0 : r.height) || (null == s ? void 0 : null === (a = s.tablet) || void 0 === a ? void 0 : a.height) || (null == s ? void 0 : null === (l = s.desktop) || void 0 === l ? void 0 : l.height)
                }
            }
            updateOptionStyles(e) {
                this.styles = {
                    ...this.styles,
                    ...e
                },
                this.checkWrapperHeight()
            }
            rerender() {
                var e;
                null === (e = this.slider) || void 0 === e || e.update()
            }
            constructor(...e) {
                super(...e),
                I(this, "componentId", ""),
                I(this, "setting", void 0),
                I(this, "styles", void 0),
                I(this, "slider", void 0),
                I(this, "sliderWrapper", void 0),
                I(this, "nextButton", void 0),
                I(this, "backButton", void 0),
                I(this, "dotContainer", void 0),
                I(this, "isHiddenArrowWhenDisabled", void 0),
                I(this, "hasRemoveSpacing", !1),
                I(this, "productFormID", void 0),
                I(this, "sliderSelector", void 0),
                I(this, "isRunningAnimation", !1),
                I(this, "isUpdated", !1),
                I(this, "previousIndex", 0),
                I(this, "loop", void 0),
                I(this, "productMedia", 0),
                I(this, "enableDrag", void 0),
                I(this, "init", () => {
                    var e;
                    let t = this.closest(".gps > section");
                    if (null == t ? void 0 : t.classList.contains("gps-lazy")) {
                        null == t || t.addEventListener("GpLazyLoaded", this.init);
                        return
                    }
                    if (null == t || t.removeEventListener("GpLazyLoaded", this.init),
                    this.componentId = this.getState("id"),
                    this.productFormID = null === (e = this.closest("gp-product form")) || void 0 === e ? void 0 : e.getAttribute("id"),
                    !this.componentId)
                        return;
                    let i = this.getAttribute("product-media");
                    if (this.productMedia = i ? Number(i) : 0,
                    this.setting = this.getState("setting"),
                    this.styles = this.getState("styles"),
                    this.getLoopSetting(),
                    this.getEnableDragSetting(),
                    this.isHiddenArrowWhenDisabled = this.getState("isHiddenArrowWhenDisabled"),
                    i && "1" === i) {
                        this.getDotContainer(),
                        this.renderSliderDots(!0);
                        let e = this.querySelector("img[data-srcset]");
                        e && !e.classList.contains("gp_lazyload") && e.classList.add("gp_lazyload");
                        return
                    }
                    this.slider = new b(`#gp-carousel-${this.componentId}`,this.getSliderOption(),[e => S(e), y]),
                    this.addEventLazyImage(),
                    this.setWrapperHeight(),
                    this.setCarouselOffset(),
                    this.onListenerChangeSlideInteraction(),
                    this.setCarouselGap();
                    let n = this.querySelector(".gem-slider");
                    null == n || n.addEventListener("click", e => {
                        var t;
                        let i = null === (t = e.target.closest(".gem-slider-item")) || void 0 === t ? void 0 : t.getAttribute("data-index");
                        this.dispatchEventSelectItem(Number(i))
                    }
                    )
                }
                ),
                I(this, "getLoopSetting", () => {
                    var e;
                    this.loop = null === (e = this.setting) || void 0 === e ? void 0 : e.loop
                }
                ),
                I(this, "getEnableDragSetting", () => {
                    var e;
                    this.enableDrag = null === (e = this.setting) || void 0 === e ? void 0 : e.enableDrag,
                    k.forEach(e => {
                        var t, i;
                        let n = this.getValueByDevice(null === (t = this.setting) || void 0 === t ? void 0 : t.enableAction, window.screenSize.getDeviceName(), !0);
                        this.enableDrag = {
                            ...this.enableDrag,
                            [e]: !!n && this.getValueByDevice(null === (i = this.setting) || void 0 === i ? void 0 : i.enableDrag, window.screenSize.getDeviceName(), !1)
                        }
                    }
                    )
                }
                ),
                I(this, "getSneakPeakByDevice", () => {
                    var e;
                    return x(null === (e = this.setting) || void 0 === e ? void 0 : e.sneakPeak, window.screenSize.getDeviceName(), !1)
                }
                ),
                I(this, "getNumberOfFullWidthShow", e => {
                    var t, i, n;
                    let o = "center" === x(null === this || void 0 === this ? void 0 : null === (t = this.setting) || void 0 === t ? void 0 : t.sneakPeakType, e) ? 2 : 1;
                    return "number" == typeof x(null === (i = this.setting) || void 0 === i ? void 0 : i.itemNumber, e, 4) ? x(null === (n = this.setting) || void 0 === n ? void 0 : n.itemNumber, e, 4) - o : void 0
                }
                ),
                I(this, "getOriginCarousel", e => {
                    var t, i;
                    let n = "center" === x(null === (t = this.setting) || void 0 === t ? void 0 : t.sneakPeakType, e) && x(null === (i = this.setting) || void 0 === i ? void 0 : i.sneakPeak, e) ? "center" : "auto";
                    return n
                }
                ),
                I(this, "getMaxNavigationWhenSneak", e => {
                    var t, i, n;
                    if ("center" !== this.getOriginCarousel(e))
                        return {};
                    let o = (null === (i = this.setting) || void 0 === i ? void 0 : null === (t = i.childItem) || void 0 === t ? void 0 : t.length) || 1
                      , r = Number(x(this.getSlideToShow(), e, 1)) || 2;
                    x(null === this || void 0 === this ? void 0 : null === (n = this.setting) || void 0 === n ? void 0 : n.sneakPeak, e) && (r = Math.trunc(Number(this.getNumberOfFullWidthShow(e)) || 1));
                    let a = o - r
                      , l = x(this.loop, e, !1);
                    return l ? {
                        max: void 0
                    } : {
                        max: a
                    }
                }
                ),
                I(this, "getActiveIndexDot", (e, t, i) => {
                    let n = e ? t : Math.ceil(t / i);
                    return this.getSneakPeakByDevice() && (n = t),
                    n
                }
                ),
                I(this, "getSlideToShowFromOldData", () => {
                    var e;
                    if (!(null === (e = this.setting) || void 0 === e ? void 0 : e.slidesToShow))
                        return null;
                    let t = {};
                    return k.forEach(e => {
                        var i;
                        let n = x(null === (i = this.setting) || void 0 === i ? void 0 : i.slidesToShow, e);
                        t[e] = n ? "auto" === n ? 4 : n : 1
                    }
                    ),
                    t
                }
                ),
                I(this, "getSlideToShow", () => {
                    let e = this.getSlideToShowFromOldData();
                    if (e)
                        return e;
                    let t = {};
                    return k.forEach(e => {
                        var i, n, o, r, a, l, s, d;
                        let u = x(null === (i = this.setting) || void 0 === i ? void 0 : i.sneakPeak, e)
                          , v = u ? "center" === x(null === (n = this.setting) || void 0 === n ? void 0 : n.sneakPeakType, e) ? null !== (s = x(null === (o = this.setting) || void 0 === o ? void 0 : o.sneakPeakOffsetCenter, e)) && void 0 !== s ? s : 0 : null !== (d = x(null === (r = this.setting) || void 0 === r ? void 0 : r.sneakPeakOffsetForward, e)) && void 0 !== d ? d : 0 : 0
                          , c = x(null === (a = this.setting) || void 0 === a ? void 0 : a.itemNumber, e) || 0
                          , h = "center" === x(null === (l = this.setting) || void 0 === l ? void 0 : l.sneakPeakType, e) ? -2 : -1;
                        t[e] = "auto" === c ? c : c + v / 100 * h
                    }
                    ),
                    t
                }
                ),
                I(this, "getDotItems", () => {
                    let {isInfinity: e, totalSliderItem: t, slidePerPage: i} = this.getSliderSetting()
                      , n = [];
                    if (this.getSneakPeakByDevice()) {
                        let i = window.screenSize.getDeviceName()
                          , o = this.getNumberOfFullWidthShow(i);
                        n = Array.from({
                            length: e ? t : t - (o || 0) + 1
                        }, (e, t) => t)
                    } else
                        n = Array.from({
                            length: e ? t : Math.ceil(t / i)
                        }, (e, t) => t);
                    return n
                }
                ),
                I(this, "onListenerChangeSlideInteraction", () => {
                    this.onTrigger && (this.onTrigger({
                        event: "gp:change-previous-slide"
                    }, e => {
                        let {isRollback: t, data: i, uniqueStorageKey: n} = e || {};
                        this.previousSlide({
                            isRollback: t,
                            data: i,
                            key: n,
                            element: this
                        })
                    }
                    ),
                    this.onTrigger({
                        event: "gp:change-next-slide"
                    }, e => {
                        let {isRollback: t, uniqueStorageKey: i, data: n} = e || {};
                        this.nextSlide({
                            isRollback: t,
                            data: n,
                            key: i,
                            element: this
                        })
                    }
                    ),
                    this.onTrigger({
                        event: "gp:change-index-slide"
                    }, e => {
                        let {isRollback: t, uniqueStorageKey: i, data: n} = e || {};
                        this.changeIndexSlideInteraction({
                            isRollback: t,
                            data: n,
                            key: i,
                            element: this
                        })
                    }
                    ))
                }
                )
            }
        }
        )
    }
    ;
    "completed" === window.gpReadyState ? O() : window.addEventListener("gp-global-loaded", O)
}();
